import { render, staticRenderFns } from "./dettaglioAlimentazione.vue?vue&type=template&id=799021ab"
import script from "./dettaglioAlimentazione.vue?vue&type=script&lang=js"
export * from "./dettaglioAlimentazione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports